/**
 * @file Especialização CEP do pipeline Input.
 * @module components/create/cep
 */

/**
 * Configura um input textual com máscara `cep`.
 *
 * Quando `label` não é informado, usa `dic.labels.zip`. O callback é armazenado
 * no próprio elemento e recebe o evento original.
 *
 * @param {HTMLInputElement} elem Input base.
 * @param {Object} options Opções recebidas pelo componente.
 * @param {Function} [options.callback] Executado no blur e também no keyup quando o valor mascarado atinge 9 caracteres.
 * @returns {Array.<HTMLInputElement|Object>} Tupla com input e `options` normalizado.
 */
export default (elem, options) => {
  options.type = 'text';
  options.mask = { template: 'cep' };

  if(options.label === undefined){
    options.label = dic.labels.zip
  }

  if (options.callback !== undefined && typeof options.callback === 'function') {
    elem.callback = options.callback;
  }

  elem.addEventListener('keyup', (e) => {
    if (e.currentTarget.value.length === 9) {
      if (typeof e.currentTarget.callback === 'function') {
        e.currentTarget.callback(e);
      }
    }
  });

  elem.addEventListener('blur', (e) => {
    if (typeof e.currentTarget.callback === 'function') {
      e.currentTarget.callback(e);
    }
});

  return [elem, options];
}
